export default {"src":"/_next/static/media/AI.1a621417.svg","height":31,"width":29,"blurWidth":0,"blurHeight":0};